import { Box, LinearProgress, Stack, Typography, useTheme } from '@mui/material'
import { OutlinedButton } from '../../../../components/Button'
import { ContainedButton } from '../../../../components/Button'

interface BottomActionsProps {
  currentStep: number
  totalSteps: number
  onBack: () => void
  onAnalyze: () => void
  isAnalyzeDisabled: boolean
}

export const BottomActions = ({
  currentStep,
  totalSteps,
  onBack,
  onAnalyze,
  isAnalyzeDisabled,
}: BottomActionsProps) => {
  const theme = useTheme()
  const progress = (currentStep / totalSteps) * 100

  const getProgressColor = () => {
    if (progress <= 30) return theme.palette.error.main
    if (progress <= 70) return theme.palette.warning.main
    return theme.palette.success.main
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.08)',
        p: 3,
      }}
    >
      <Box 
        sx={{ 
          maxWidth: 500, 
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Box sx={{ flex: 1, maxWidth: 170 }}>
            <LinearProgress 
              variant="determinate" 
              value={progress} 
              sx={{
                backgroundColor: '#E6EEF4',
                '& .MuiLinearProgress-bar': {
                  backgroundColor: getProgressColor(),
                },
                height: 8,
                borderRadius: 4,
              }}
            />
          </Box>
          <Typography 
            sx={{ 
              fontSize: '12px',
              fontWeight: 500,
              ml: 1,
            }}
          >
            {currentStep}/{totalSteps}
          </Typography>
        </Stack>

        <Stack 
          direction={{ xs: 'column', md: 'row' }} 
          spacing={2} 
          justifyContent="center"
        >
          <OutlinedButton
            fullWidth
            size="large"
            onClick={onBack}
            sx={{
              py: 1.5,
              px: 4,
              backgroundColor: 'white',
              border: '1px solid #D0D5DD',
              color: '#475467',
              borderRadius: 2,
              '&:hover': {
                backgroundColor: '#F9FAFB',
                borderColor: '#D0D5DD',
              },
            }}
          >
            Back
          </OutlinedButton>

          <ContainedButton
            fullWidth
            size="large"
            onClick={onAnalyze}
            disabled={isAnalyzeDisabled}
            sx={{
              py: 1.5,
              px: 4,
              backgroundColor: theme.palette.button.default,
              borderRadius: 2,
              '&:hover': {
                backgroundColor: theme.palette.button.hover,
              },
            }}
          >
            Analyze result
          </ContainedButton>
        </Stack>
      </Box>
    </Box>
  )
} 